/* eslint-disable import/first */
import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate, useLocation } from '@reach/router';
import { FormattedMessage, useIntl } from 'react-intl';
import { numberWithSpaces } from 'spwa-ui-library/esm/utils/helper';
import { RiSettings4Line } from '@react-icons/all-files/ri/RiSettings4Line';
import { RiUserAddLine } from '@react-icons/all-files/ri/RiUserAddLine';
import ClassNames from 'classnames';
import css from './index.module.scss';

const SideMenuProfileCard = ({ setMenuClose, isLoggedIn }) => {
  const profile = useSelector((state) => state.profile);
  const profileData = profile.data.data?.[0];
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const handleProfile = () => {
    profileData.profileStep === 1 || (profileData.profileStep === 0 && profileData.email !== '')
      ? navigate(`/${intl.locale}/profile`, {
          state: {
            oldLocation: JSON.parse(JSON.stringify(location)),
          },
        })
      : navigate(`/${intl.locale}/create-profile`, {
          state: {
            oldLocation: JSON.parse(JSON.stringify(location)),
          },
        });

    if (!profileData) {
      return '';
    }
    if (setMenuClose) {
      setMenuClose();
    }
  };

  const handleLogin = () => {
    setMenuClose();
    navigate(`/${intl.locale}/login`, {
      state: {
        oldLocation: JSON.parse(JSON.stringify(location)),
      },
    });
  };

  return (
    <>
      <Box className={ClassNames(css.profileSection, { [css.desktopCursorView]: isLoggedIn })}>
        {/* <Box className={css.profileSection}> */}
        {isLoggedIn ? (
          <Grid container spacing={2} onClick={handleProfile}>
            <Grid xs={2}>
              <Grid>
                <Grid className={css.circleArea1}>
                  {profileData.name.toUpperCase()[0] || <RiUserAddLine />}
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={8} className={css.profileBox}>
              <Typography className={css.profileText} component="div">
                {profileData?.name || (
                  <FormattedMessage
                    id="pleaseCreateProfile"
                    defaultMessage="Please Create Profile"
                  />
                )}
              </Typography>
              {profileData.profileStep ? (
                <Typography className={css.profilePhn} component="div">
                  {profileData?.fullPhnNo
                    ? numberWithSpaces(profileData.fullPhnNo, '#### ### ### ###')
                    : 'Add a local number for exclusive offers'}
                </Typography>
              ) : (
                ''
              )}
            </Grid>
            <Grid xs={2} className={css.profileGrid}>
              {profileData?.name && (
                <RiSettings4Line style={{ width: '1.8rem', height: '1.9rem' }} />
              )}
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={2}>
            <Grid xs={2}>
              <Grid className={css.circleArea1}>
                <RiUserAddLine />
              </Grid>
            </Grid>
            <Grid xs={7} className={css.plsLoginTextArea}>
              <Typography className={css.plzLoginTypo} component="div">
                <FormattedMessage id="Login-unlock" defaultMessage="Login-unlock" />{' '}
                <strong>
                  <FormattedMessage id="Offers-discounts" defaultMessage="Offers-discounts" />
                </strong>
              </Typography>
            </Grid>
            <Grid xs={3} className={css.profileGrid}>
              <Button className={css.loginButton} variant="contained" onClick={handleLogin}>
                <FormattedMessage id="navigation_login" defaultMessage="login" />
              </Button>
            </Grid>
          </Grid>
        )}
      </Box>
    </>
  );
};

export default SideMenuProfileCard;
